// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"FlagDialog_checkbox__1rbDO"};